import moment from 'moment-timezone'

import {
  DepartmentNode,
  EquipmentPerformance,
  EquipmentPerformanceDto,
  KpiAssignmentDto,
  KpiOption,
  ManualKpi,
  ManualKpiDto,
  TreeNode
} from '../types'

export const mapManualKpis = (manualKpis: ManualKpiDto[], timezone: string): ManualKpi[] =>
  manualKpis.map((manualKpi: ManualKpiDto) => ({
    ...manualKpi,
    createdAt: moment.utc(manualKpi.createdAt).tz(timezone),
    updatedAt: moment.utc(manualKpi.updatedAt).tz(timezone),
    timestamp: moment.utc(manualKpi.timestamp).tz(timezone)
  }))

export const mapEquipmentPerformances = (
  data: EquipmentPerformanceDto[],
  timezone: string
): EquipmentPerformance[] =>
  data.map((item) => ({
    ...item,
    kpiPerformance: item.kpiPerformance && {
      kpiAssignments:
        item.kpiPerformance.kpiAssignments &&
        item.kpiPerformance.kpiAssignments.map((assignment: KpiAssignmentDto) => ({
          ...assignment,
          result: assignment.result && {
            ...assignment.result,
            startTime: moment(assignment.result.startTime).tz(timezone),
            endTime: moment(assignment.result.endTime).tz(timezone)
          }
        }))
    }
  }))

export const mapDepartmentOptions = (options: DepartmentNode[]): KpiOption[] =>
  options.map((option) => ({
    id: option.upmId,
    label: option.displayValue ?? option?.type?.name ?? option.text ?? option.upmId
  }))

export const enrichNodePath = <T extends TreeNode>(node: T, parentPath: string = ''): T => {
  const nodeCode = node.type?.code
  const nodePath = parentPath + (nodeCode ? (parentPath ? '_' : '') + nodeCode : '')

  const children = (node.children || []).map((child: TreeNode) => enrichNodePath(child, nodePath))
  return {
    ...node,
    children,
    entityCodesPath: nodePath
  }
}
